<template>  
    <div class="SearchDalog">
      <el-dialog  
          :title="searchData.title" 
          width="600px"
          append-to-body
          :visible.sync="visible" 
          @close="clearData" 
          :show="show">
          <div class="content_box">
            <div class="content_top">
              <el-input v-model="searchText" size="mini" placeholder="输入助记码/编号/名称" class="search_input"></el-input>
              <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
            </div>
            <div class="content_infor_box">
                <TreeTable class="right" :tableData="tableData" :tableConfigData="tableConfigData" :isInner="isInner" @rowdblclick="rowdblclick" @clickIcon="clickIcon"/>
            </div>
          </div>
          <!-- 分页 -->
          <el-pagination
              style="margin:10px auto 0;display: flex;justify-content: center;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20,50,100]"
              :page-size="pageSize"
              layout="total, sizes,prev, pager, next, jumper"
              :total="total"
              ></el-pagination>
      </el-dialog>
    </div> 

</template>  

<script>
import tool from "@/utils/tool";//本地缓存存取

const CustomConfig = [
    {Label:'名称',Key:'FullName'},
    {Label:'编号',Key:'BaseCode'},
    {Label:'助记码',Key:'PyNo'},
    {Label:'所属分类',Key:'ClientType'},
    {Label:'单位电话',Key:'UnitPhone'},
    {Label:'单位地址',Key:'Address'},
    {Label:'传真号码',Key:'FaxNum'},
    {Label:'联系人',Key:'LinkMan'},
    {Label:'联系电话',Key:'LinkPhone'},
    {Label:'默认经手人',Key:'EtypeId'},
    {Label:'电子邮箱',Key:'Email'},
    {Label:'单位邮编',Key:'PostCode'},
    {Label:'微信号',Key:'WeChatId'},
    {Label:'开户账号',Key:'BankAndAcount'},
    {Label:'单位税号',Key:'TaxNum'},
    {Label:'备注',Key:'Memo'},
    {Label:'应收上限',Key:'ARLimit'},
    {Label:'应付上限',Key:'APLimit'},
    {Label:'收款期限',Key:'SkLimit'},
    {Label:'价格选择',Key:'DeftPrice'},
    {Label:'换货比列',Key:'ChgGoodScale'},
    {Label:'默认折扣',Key:'Discount'},
];
const WarehouseConfig = [
    {Label:'名称',Key:'FullName'},
    {Label:'编号',Key:'BaseCode'},
    {Label:'助记码',Key:'PyNo'},
    {Label:'仓库分类',Key:'StType'},
    {Label:'备注',Key:'Memo'},
];
const HandlersConfig = [
    {Label:'职员名称',Key:'FullName'},
    {Label:'职员编号',Key:'BaseCode'},
    {Label:'助记码',Key:'PyNo'},
    // {Label:'职员分类',Key:'BaseCode'},
    {Label:'生日',Key:'Birthday'},
    {Label:'入职时间',Key:'InJobDate'},
    {Label:'联系电话',Key:'LinkTel'},
    {Label:'所在部门',Key:'DeptId'},
    {Label:'移动电话',Key:'HandTel'},
    {Label:'文化程度',Key:'EducateLevel'},
    {Label:'身份证号',Key:'IDCard'},
    {Label:'职务',Key:'Incumbency'},
    // {Label:'默认仓库',Key:'BaseCode'},
    {Label:'是否能更改仓库',Key:'ChangeKType'},
    // {Label:'每单优惠限额',Key:'BaseCode'},
    // {Label:'状态',Key:'BaseCode'},
    {Label:'备注',Key:'Memo'},
];
const DepartmentConfig = [
    {Label:'部门名称',Key:'FullName'},
    {Label:'部门编号',Key:'BaseCode'},
    {Label:'助记码',Key:'PyNo'},
    // {Label:'每单优惠限额',Key:'BaseCode'},
    // {Label:'状态',Key:'BaseCode'},
    {Label:'备注',Key:'Memo'},
];

const AreaConfig = [
    {Label:'名称',Key:'FullName'},
    {Label:'编号',Key:'BaseCode'},
    {Label:'助记码',Key:'PyNo'},
    {Label:'地区分类',Key:'ParentNos'},
    {Label:'状态',Key:'StopedName'},
    {Label:'备注',Key:'Memo'},
];

export default {
    data () {  
        return {
            visible: this.show,
            searchText:'',//收索内容
            
            tableData:[],//table表格数据
            tableConfigData:[],//表格表头配置字段
            isInner:true,
            // 分页
            currentPage: 1, //当前页码
            total: 0, //总页数
            pageSize: 10, //每页显示数量
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        fieldData:String,
        searchData:Object,
    },
    methods:{
        // 请求table表格数据
        InitTable(typeId){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                pagesize:this.pageSize,
                pagenum:this.currentPage,
                ParentNo:0,
                type:0,//type=0查询所有一级数据  type=1查询所有末端数据
                Stoped:this.$attrs.pargam.Stoped,//是否数据的状态 0启用 1停用  不传两者都有
                style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                // KtypeId:this.$attrs.pargam.KtypeId,//仓库ID,KFlag为1才生效
                // BtypeId:this.$attrs.pargam.BtypeId,//客户&供应商ID,KFlag为1才生效
            }
            this.request.post(this.searchData.url2, {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    // console.log('===---->',res)
                    this.total = res.count;
                    this.tableData = res.data;
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 点击收索按钮
        searchClick(){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                Keywords:this.searchText,
                pagesize:10,
                pagenum:1,
                Stoped:this.$attrs.pargam.Stoped,//是否数据的状态 0启用 1停用  不传两者都有
            }
            this.request.post(this.searchData.url3, {jparams:JSON.stringify(params)})
            .then(res => {
                // 接收后端发送回来的数据
                // console.log(res);
                this.total = res.count;
                this.tableData = res.data;
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 条件查询table数据
        QueryTable(ParentId){
            let params;
            if(this.searchData.interface == 2){
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    pagesize:10,
                    pagenum:1,
                    Stoped:this.$attrs.pargam.Stoped,//是否启用
                    DeptId:ParentId,//部门ID
                    style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                }
            }else{
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    pagesize:10,
                    pagenum:1,
                    ParentNo:ParentId,
                    Stoped:this.$attrs.pargam.Stoped,//是否启用
                    style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                }
            }
            this.request.post(this.searchData.url3, {jparams:JSON.stringify(params)})
                .then(res => {
                    // 接收后端发送回来的数据
                    // console.log(res);
                    this.total = res.count;
                    this.tableData = res.data;
                    // console.log(this.tableData);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 当前页显示条数发生变化时
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
        },
        // 当前页发生变化时
        handleCurrentChange(val) {
            // console.log(val);
            this.currentPage = val;
        },
        // 点击table头部图标返回上一级
        clickIcon(){
            this.isInner = true;
            this.InitTable(0);
        },
        // 双击table行元素
        rowdblclick(data){
            // console.log(data);
            let typeId;
            if(this.searchData.interface==0){
                typeId = data.BtypeId;
            }
            if(this.searchData.interface==1){
                typeId = data.KtypeId;                
            }
            if(this.searchData.interface==2){
                typeId = data.EtypeId;
            }
            if(this.searchData.interface==3){
                typeId = data.AreaId;
            }
            if(this.searchData.interface==4){
                typeId = data.DeptId;
            }
            if(this.searchData.PtypeId==5){
                typeId = data.AreaId;
            }
            if(data.IsDir && this.searchData.interface != 4){
                this.QueryTable(typeId);
                this.isInner = false;
            }else{
                // console.log(data,'处理数据回填');
                this.$emit('dbclickRow',data,this.fieldData,typeId)
                this.$emit('update:show', false)
            }
        },
        // 退出清除数据
        clearData(){
            // 退出前是数据初始化
            this.isInner = true;
            this.$emit('update:show', false);
        },
    },
    watch: {
        show (){  
            this.visible = this.show;
            this.isInner = true;
            this.InitTable(0);
        },
    },
    created(){
        // console.log('====',this.searchData.interface)
        switch (this.searchData.interface) {
            case 0:
                // 客户
                this.tableConfigData = CustomConfig;
                break;
            case 1:
                // 仓库
                this.tableConfigData = WarehouseConfig;
                break;
            case 2:
                // 经手人
                this.tableConfigData = HandlersConfig;
                break;
            case 3:
                // 地区
                this.tableConfigData = AreaConfig;
                break;
            case 4:
                // 部门
                this.tableConfigData = DepartmentConfig;
                break;
            case 5:
                // 商品选择
                // this.tableConfigData = DepartmentConfig;
                break;  
            case 6:
                // 银行账户
                // this.tableConfigData = DepartmentConfig;
                break;  
            case 7:
                // 商品单位
                // this.tableConfigData = DepartmentConfig;
                break;
            case 8:
                // 商品颜色
                // this.tableConfigData = DepartmentConfig;
                break;  
            case 9:
                // 商品尺码
                // this.tableConfigData = DepartmentConfig;
                break;
            case 10:
                // 商品厂家
                // this.tableConfigData = DepartmentConfig;
                break;  
            default:
                break;
        }
    },
     // 创建生命周期钩子函数
    mounted() {
        // 初始化数据
        this.InitTable(0);
    },
};  
</script>

<style lang="less">
  .el-dialog__header{
      background: rebeccapurple;
      // background: #4990d7;
      padding: 10px 10px 0;
      .el-dialog__title{
        color: #fff;
        font-size: 14px;
      }
      .el-dialog__headerbtn{
        top: 10px;
        right: 10px;
        .el-dialog__headerbtn .el-dialog__close{
          color: #fff;
        }
      }
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
  .content_box{
    .content_top{
      width: 100%;
      height: 40px;
      display: -webkit-box !important;
      display: box !important;
      position:relative;
      -webkit-box-align:center;
      box-align:center;
      .search_input{
        display: block;
        width: 200px;
      }
    }
    .content_infor_box{
        width: 100%;
        height: 300px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        .right{
            height: 100%;
            position:relative;
            -webkit-box-flex: 1; 
            box-flex: 1;
        }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Dialog/SearchBankDialog/SearchBankDialog.vue